var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "29.84px",
    height: "27.61px",
    viewBox: "0 0 29.84 27.61",
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 29.84 27.61"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.17,25.94c5.4,0.08,5.4-8.42,0-8.33C18.76,17.52,18.76,26.02,24.17,25.94z M24.17,27.6 c7.56,0.12,7.56-11.78,0-11.67C16.6,15.82,16.6,27.72,24.17,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.17,18.85c1.21-0.03,0.75,1.87,0.83,2.57c0.78,0.48,1.29,1.86,0,2c-0.53,0.08-1.31-1.04-1.66-1.31 C23.49,21.38,22.81,18.81,24.17,18.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.67,11.77H5v1.67h1.67V11.77z M5,10.1c-1.79-0.03-1.74,2.07-1.67,3.33C3.3,15.23,5.4,15.18,6.67,15.1 c1.79,0.03,1.74-2.07,1.67-3.33C8.37,9.98,6.27,10.03,5,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.33,11.77h-1.67v1.67h1.67V11.77z M11.67,10.1c-1.79-0.03-1.74,2.07-1.67,3.33 c-0.03,1.79,2.07,1.74,3.33,1.67c1.79,0.03,1.74-2.07,1.67-3.33C15.04,9.98,12.93,10.03,11.67,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,11.77h-1.67v1.67H20V11.77z M18.33,10.1c-1.79-0.03-1.74,2.07-1.67,3.33c-0.03,1.79,2.07,1.74,3.33,1.67 c1.79,0.03,1.74-2.07,1.67-3.33C21.7,9.98,19.6,10.03,18.33,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.67,18.44H5v1.67h1.67V18.44z M5,16.77c-1.79-0.03-1.74,2.07-1.67,3.33c-0.03,1.79,2.07,1.74,3.33,1.67 c1.79,0.03,1.74-2.07,1.67-3.33C8.37,16.65,6.27,16.69,5,16.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.33,18.44h-1.67v1.67h1.67V18.44z M11.67,16.77C9.88,16.74,9.92,18.84,10,20.1 c-0.03,1.79,2.07,1.74,3.33,1.67c1.79,0.03,1.74-2.07,1.67-3.33C15.04,16.65,12.93,16.69,11.67,16.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.67,2.6c-0.12-1.55,4.26-0.58,5-0.83V0.1C4.61,0.25-0.07-0.76,0,2.6c0,0,0,20,0,20 c-0.03,1.34,1.16,2.53,2.5,2.5c0,0,16.88,0,16.88,0c-0.36-0.51-0.63-1.07-0.8-1.67C18,23.03,1.05,24.41,1.67,22.6 C1.67,22.6,1.67,2.6,1.67,2.6z M23.33,16c0.55-0.08,1.11-0.08,1.67,0V2.6c0.05-2.69-3.1-2.62-5-2.5v1.67 c0.74,0.17,3.38-0.54,3.33,0.83C23.33,2.6,23.33,16,23.33,16z M8.33,1.77h8.8V0.1h-8.8V1.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.33,0.1h-10C8.17,0.84,8.87,3.49,7.5,3.44C6.13,3.49,6.83,0.84,6.67,0.1C5.24,0.36,0.74-0.82,0.83,1.77 c0.2,0.93-0.45,4.69,0.49,5.35C1.16,8.17,21.93,7.36,22.5,7.6c0.89,0.02,1.68-0.77,1.67-1.67c-0.1-3.8,1.08-6.51-4.17-5.83 c-0.16,0.74,0.54,3.38-0.83,3.33C17.8,3.49,18.49,0.84,18.33,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,7.6H1.67V5.94H25V7.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date_icon.ffb4de1f2fe94c66433b607d61dded42.svg";
export { ForwardRef as ReactComponent };